import store from 'store2'

import post from '../../../lib/post'

export default function(done){

  var ombStore = store.namespace('omb')

  post(
    'data',
    {
      type: 'updateReports',
      token: ombStore('token'),
    },
    function(error){
      if(error){
        console.log(error)
        done(error)
      } else {
        if(done){
          done()
        }
      }
    }
  )

}



// WEBPACK FOOTER //
// ./src/client/view/admin/lib/refreshReports.js